import { FieldErrors } from 'common/components/core/FieldErrors'
import React from 'react'
import { PublicPageFieldSlugEnum } from 'src/public-pages/enums/public-page-field-slug-enum'
import { useTwoFactorAuthSubmit } from 'src/public-pages/hooks/use-two-factor-auth-submit'
import { WebsitePublicLogo } from 'src/public-pages/shared/components/layout/website-public-logo'
import { PublicPageButton } from 'src/public-pages/shared/components/public-page-button'
import { PublicPageField } from 'src/public-pages/shared/components/public-page-field'
import { PublicPageHeading } from 'src/public-pages/shared/components/public-page-heading'
import { PublicPageLink } from 'src/public-pages/shared/components/public-page-link'
import { PublicPageText } from 'src/public-pages/shared/components/public-page-text'
import CommonCheckbox from 'src/shared/components/checkbox'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'
import {
  WebsiteButtonsInterface,
  WebsiteFormFieldsSettings,
  WebsiteThemeInterface,
  WebsiteTypographySettingsStylesInterface,
} from 'src/shared/types/website-settings-types'
export interface TwoFactorAuthContentProps {
  logoUrl?: string
  isCustomDomain?: boolean
  heading?: WebsiteTypographySettingsStylesInterface
  paragraph?: WebsiteTypographySettingsStylesInterface
  theme?: WebsiteThemeInterface
  formFields?: Partial<WebsiteFormFieldsSettings>
  button?: Partial<WebsiteButtonsInterface>
  linkButton?: Partial<WebsiteButtonsInterface>
}

export const TwoFactorAuthContent: React.FC<TwoFactorAuthContentProps> = ({
  logoUrl,
  isCustomDomain,
  heading,
  theme,
  formFields,
  paragraph,
  button,
  linkButton,
}) => {
  const { t } = useTypedTranslation()
  const {
    authCode,
    setAuthCode,
    trusted,
    setTrusted,
    handleSubmit,
    loading,
    errors,
  } = useTwoFactorAuthSubmit()

  return (
    <div>
      <WebsitePublicLogo
        logoUrl={logoUrl}
        isCustomDomain={isCustomDomain}
        alt="Logo"
      />
      <PublicPageHeading
        heading={heading}
        theme={theme}
        style={{ marginBottom: '10px' }}
      >
        {t('website_public_page.2fa.heading')}
      </PublicPageHeading>
      <PublicPageText
        paragraph={paragraph}
        theme={theme}
        style={{ marginBottom: '40px' }}
        textAlign="center"
      >
        {t('website_public_page.2fa.sub_heading')}
      </PublicPageText>
      <div style={{ marginBottom: '16px' }}>
        <div style={{ marginBottom: '12px' }}>
          <PublicPageText
            paragraph={paragraph}
            theme={theme}
            style={{ marginBottom: '10px' }}
          >
            {t('website_public_page.2fa.verification_code.label')}
          </PublicPageText>
          <PublicPageField
            type={PublicPageFieldSlugEnum.TwoFactorAuthCode}
            name={PublicPageFieldSlugEnum.TwoFactorAuthCode}
            formFields={formFields}
            theme={theme}
            value={authCode}
            onChange={e => setAuthCode(e.target.value)}
          />
          <FieldErrors
            errors={errors?.[PublicPageFieldSlugEnum.TwoFactorAuthCode]}
            fontFamily={paragraph?.fontFamily}
          />
          <FieldErrors
            errors={errors?.root}
            fontFamily={paragraph?.fontFamily}
          />
        </div>
        <div style={{ marginBottom: '36px' }}>
          <CommonCheckbox
            uiProps={{ htmlAttrId: 'two-factor-trusted' }}
            checked={trusted}
            onChangeHandler={() => setTrusted(prev => !prev)}
          >
            <PublicPageText
              paragraph={paragraph}
              theme={theme}
              style={{ margin: '0 0 8px 12px' }}
            >
              {t('website_public_page.2fa.default_checkbox')}
            </PublicPageText>
          </CommonCheckbox>
        </div>
        <PublicPageButton
          button={button}
          theme={theme}
          text={t('website_public_page.login.button_text')}
          loading={loading}
          onClick={handleSubmit}
          width="100%"
          paragraph={paragraph}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <PublicPageLink
          linkButton={linkButton}
          paragraph={paragraph}
          theme={theme}
          href="/dashboard/logout"
          textAlign="left"
        >
          {t('website_public_page.2fa.different_email')}
        </PublicPageLink>
      </div>
    </div>
  )
}
